<script setup>
import { computed, ref } from 'vue'
import { useDate } from 'vuetify'

const props = defineProps({
  modelValue: { type: String, default: '' },
  label: { type: String, required: true },
})
const emit = defineEmits(['update:modelValue'])
const menuOpen = ref(false)
const adapter = useDate()
const selectedDate = computed(() => props.modelValue ? adapter.parseISO(props.modelValue) : null)

const selectDate = (value) => {
  emit('update:modelValue', value ? adapter.toISO(value) : '')
  menuOpen.value = false
}
const clearDate = () => {
  emit('update:modelValue', '')
  menuOpen.value = false
}
</script>

<template>
  <v-menu v-model="menuOpen" :close-on-content-click="false">
    <template #activator="{ props: activatorProps }">
      <v-text-field
        v-bind="activatorProps"
        :model-value="modelValue"
        :label="label"
        placeholder="Select a date"
        persistent-placeholder
        density="comfortable"
        prepend-inner-icon="mdi-calendar"
        readonly
        clearable
        @click:clear.stop="clearDate"
        @keydown.enter.prevent="menuOpen = true"
        @keydown.space.prevent="menuOpen = true"
        @keydown.down.prevent="menuOpen = true"
      />
    </template>
    <v-date-picker
      :model-value="selectedDate"
      :title="label"
      color="primary"
      hide-header
      @update:model-value="selectDate"
    />
  </v-menu>
</template>
